import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconMinus = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M5 11h14v2H5z" }) }));
const Memo = memo(SvgIconMinus);
export default Memo;
//# sourceMappingURL=IconMinus.js.map